<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-white">
            <CCol sm="12" lg="12" style="width: 90%; background-size: cover; margin: auto;">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin: 5%">
                            <div class="text-center">
                                <br /><br /><br />
                                <h1 class="custom-text-aladdin text-black poppin-font text-48px">
                                    Portal Jobs
                                </h1>
                                <p class="custom-16px-400 text-center ml-4">Portal jobs typically involve working in an office environment, though remote work options are often available. The role may require collaboration with other IT professionals, content creators, and end-users to ensure the portal
                                    meets user needs and organizational goals.</p>
                            </div>
                        </div>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-FAFAFA">
                            <div class="p-2 ml-2">
                                <label class="custom-16px-600 mt-5 ml-2">Filter by</label>
                                <br />
                                <div>
                                    <div class="custom-14px-500 ml-2 mt-2 font-color-171717" @click="toggleCategoryList">
    
    
                                        <CRow class="mb-2">
                                            <CCol sm="10">Category</CCol>
                                            <CCol sm="2">
                                                <span v-if="isCategoryListVisible"><img src="../assets/img/arrowup-black.png" style="max-width:20px"/></span>
                                                <span v-else><img src="../assets/img/arrowdown-black.png" style="max-width:20px"/></span>
                                            </CCol>
    
                                        </CRow>
    
                                    </div>
                                    <div v-if="isCategoryListVisible">
                                        <CRow v-for="item in categoryJob" :key="item.Id" class="m-1">
                                            <CCol sm="2">
                                                <input type="checkbox" />
                                            </CCol>
                                            <CCol sm="10">
                                                <label class="font-color-171717">{{ item.Category }}</label>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
    
    
                                <div>
                                    <div class="custom-14px-500 ml-2 mt-2 font-color-171717" @click="toggleTypeList">
    
    
                                        <CRow class="mb-2">
                                            <CCol sm="10">Job Type</CCol>
                                            <CCol sm="2">
                                                <span v-if="isTypeListVisible"><img src="../assets/img/arrowup-black.png" style="max-width:20px"/></span>
                                                <span v-else><img src="../assets/img/arrowdown-black.png" style="max-width:20px"/></span>
                                            </CCol>
    
                                        </CRow>
    
                                    </div>
                                    <div v-if="isTypeListVisible">
                                        <CRow v-for="item in categoryJobType" :key="item.Id" class="m-1">
                                            <CCol sm="2">
                                                <input type="checkbox" />
                                            </CCol>
                                            <CCol sm="10">
                                                <label class="font-color-171717">{{ item.Category }}</label>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
    
    
                                <div>
                                    <div class="custom-14px-500 ml-2 mt-2 font-color-171717" @click="toggleSeniorityList">
    
    
                                        <CRow class="mb-2">
                                            <CCol sm="10">Seniority Level</CCol>
                                            <CCol sm="2">
                                                <span v-if="isTypeSeniorityListVisible"><img src="../assets/img/arrowup-black.png" style="max-width:20px"/></span>
                                                <span v-else><img src="../assets/img/arrowdown-black.png" style="max-width:20px"/></span>
                                            </CCol>
    
                                        </CRow>
    
                                    </div>
                                    <div v-if="isCategorySeniorityVisible">
                                        <CRow v-for="item in categoryJobSeniority" :key="item.Id" class="m-1">
                                            <CCol sm="2">
                                                <input type="checkbox" />
                                            </CCol>
                                            <CCol sm="10">
                                                <label class="font-color-171717">{{ item.Category }}</label>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                            </div>
    
    
                        </CCard>
                    </CCol>
                    <CCol sm="8">
                        <CRow>
                            <CCol sm="7">
                                <input type="text" class="custom-input-app p-20" style="height:20px;padding:18px" placeholder="Search for job..." />
                            </CCol>
                            <CCol sm="2"> <input type="text" class="custom-input-app p-20" style="height:20px;padding:18px" placeholder="Location.." /></CCol>
                            <CCol sm="3">
                                <CButton class="custom-border-purple text-white" @click="GoToVideo()">Search</CButton>
                            </CCol>
                           
                            <CCol sm="6">
                              
                                <label class="custom-14px-500 font-color-928AFD mt-3 mb-3">2</label> <span class="font-color-696969">jobs found</span>
                                <CCard class="border-16px">
                                    <div class="m-3">
                                        <CRow>
                                            <CCol sm="10">
                                                <img src="../assets/img/Google-icon.png" style="max-width:32px" />
                                            </CCol>
                                            <CCol sm="2">
                                                <img v-if="isLoved" src="../assets/img/love-red.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                                <img v-else src="../assets/img/love-white.png" @click="toggleLove" style="max-width: 32px; cursor: pointer;" />
                                            </CCol>
                                            <CCol sm="12" class="mt-3">
                                                <label class="custom-18px-600">
                                                    Sr. UI/UX Designer
                                                </label>
                                                <br />
                                                <label class="custom-14px-500 font-color-928AFD mt-1">Figma</label>
                                                <br /><br />
                                                <CRow>
                                                    <CCol sm="6"> <img src="../assets/img/icon-user.png" style="max-width:20px"/> 
                                                <label class="custom-14px-500 font-color-696969 ml-3">1-3 year</label></CCol>

                                                <CCol sm="6"> <img src="../assets/img/timer.png" style="max-width:20px"/> 
                                                <label class="custom-14px-500 font-color-696969 ml-3">Remote</label></CCol>

                                                <CCol sm="12"> <img src="../assets/img/location 2.png" style="max-width:20px"/> 
                                                <label class="custom-14px-500 font-color-696969 ml-3">Johor</label>
                                            <br />
                                            <label class="custom-14px-400 font-color-696969">
                                                This position is for a Senior UI/UX Designer who collaborates with cross-functional teams, creates user-centered designs, and conducts usability testing. This role 
                                                is ideal for someone who enjoys shaping digital experiences with a focus on user needs.
                                            </label>
                                            <br /><br />
                                            <span class="custom-light-purple font-color-928AFD border-radius-half mr-2">Web Design</span>
                                            <span class="custom-light-purple font-color-928AFD border-radius-half">App Design</span>
                                            <CRow class="mt-3">
                                                <CCol sm="5">
                                                    <label class="custom-20px-600">$1K</label> <span class="font-color-696969">/ years</span>
                                                </CCol>
                                                <CCol sm="7">
                                                    <label class="custom-14px-500 font-color-928AFD mt-1">10 hours ago</label>
                                                    <label class="font-color-696969 ml-2">120 applicants</label>
                                                </CCol>
                                            </CRow>
                                            </CCol>


                                                </CRow>
                                               
                                                </CCol>
                                        </CRow>
    
                                    </div>
    
                                </CCard>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isCategoryListVisible: true, // Toggle state
            isTypeListVisible: false,
            isCategorySeniorityVisible: false,
            categoryJob: [],
            categoryJobType: [],
            categoryJobSeniority: [],
            isLoved: false, // Initial state
        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        this.GetListCategoryJob();
        this.GetListCategoryJobType();
        this.GetListCategoryJobSeniority();
    },
    methods: {
        async GetListCategoryJob() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJob);
                if (response.status === 200) {
                    this.categoryJob = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleCategoryList() {
            this.isCategoryListVisible = !this.isCategoryListVisible;
        },

        async GetListCategoryJobType() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobType);
                if (response.status === 200) {
                    this.categoryJobType = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleTypeList() {
            this.isTypeListVisible = !this.isTypeListVisible;
        },

        async GetListCategoryJobSeniority() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobSeniority);
                if (response.status === 200) {
                    this.categoryJobSeniority = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleSeniorityList() {
            this.isCategorySeniorityVisible = !this.isCategorySeniorityVisible;
        },
        toggleLove() {
            this.isLoved = !this.isLoved;
        },

    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>